import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://7bf2ab77717b395d14565b034acb7507@o4509370035732480.ingest.us.sentry.io/4509679340158976',
  sendDefaultPii: true,
});

ReactDOM.render(<App />, document.getElementById('root'));
